import { FileSignIcon } from './FileSignIcon';

/**
 * author: Michael Irigoyen
 * id F6BB607C-B55A-4E62-8C45-490F6AE9F0A2
 * name file-sign
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-sign.svg
 * tags
 * - Banking 
 * - Files / Folders 
 */
export const ContractSignIcon = FileSignIcon;
export default ContractSignIcon